import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonHeader, IonFooter, IonContent } from '@ionic/react'
import { storeMobx } from 'restaurant'
import { formatCardNumber } from '@utils'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  cardNo: string;
  reject?: () => void;
  resolve?: () => void;
}

const BindTipModal: FC<IProps> = (props: IProps) => {
  const {
    cardNo,
    reject,
    resolve,
  } = props
  const { brand } = storeMobx
  return (
    <IonModal
      cssClass='bind-tip-modal'
      isOpen
      showBackdrop
      swipeToClose
    >
      <IonHeader className='modal-header'>
        <span>{i18n.t('mkt.giftCard.giftCardBind')}</span>
      </IonHeader>
      <IonContent>
        <div className='modal-content'>
          <span>{i18n.t('mkt.giftCard.bindTip', { brandName: brand.brandName, cardNo: formatCardNumber(cardNo) })}</span>
        </div>
      </IonContent>
      <IonFooter className='modal-footer'>
        <div className='btn cancel' data-cypid='bindTipModalCancel' onClick={reject}>
          <span>{i18n.t('mkt.common.backToDetails')}</span>
        </div>
        <div className='btn confirm' data-cypid='bindTipModalConfirm' onClick={resolve}>
          <span>{i18n.t('mkt.common.toUse')}</span>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(BindTipModal)
